import { h } from 'preact';
const Close = (props) => (<svg viewBox="0 0 20 20" class={props.class}>
	<polygon points="14.6224146 4.92544493 13.5449735 3.84800385 9.23520924 8.15776816 4.92544493 3.84800385 3.84800385 4.92544493 8.15776816 9.23520924 3.84800385 13.5449735 4.92544493 14.6224146 9.23520924 10.3126503 13.5449735 14.6224146 14.6224146 13.5449735 10.3126503 9.23520924" />
	</svg>
);
export default Close;


// WEBPACK FOOTER //
// ../q-components/components/icons/close/index.js